import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import SubmitButton from "../SubmitButton/SubmitButton";
import { ConditionalWrapper } from "../ConditionalWrapper";
import { Affix } from "antd";

const ButtonBar = ({ affix = true, ...props }) => {
  return (
    <ConditionalWrapper
      condition={affix}
      wrapper={children => (
        <Affix offsetBottom={!props.top} offsetTop={props.top}>
          {children}
        </Affix>
      )}
    >
      <div className={`${props.top ? "top" : "bottom"}_bar`}>
        {getBarButtons(props)}
      </div>
    </ConditionalWrapper>
  );
};

export default ButtonBar;

const getBarButtons = props => {
  return (
    <Row
      className={`justify-content-${
        props.left ? "start" : "end"
      } button-bar-row`}
    >
      {props.onClose ? (
        <Col md="auto" xs="auto" className="button-bar-cols">
          <SubmitButton type="close" onClick={props.onClose} />
        </Col>
      ) : null}
      {props.onSearch ? (
        <Col md="auto" xs="auto" className="button-bar-cols">
          <SubmitButton
            type="search"
            text={labels.search}
            onClick={props.onSearch}
            showLoader
          />
        </Col>
      ) : null}
      {props.onSearchReset ? (
        <Col md="auto" xs="auto" className="button-bar-cols">
          <Button
            className="buttonStyle"
            variant="danger"
            title={labels.resetAdvancedSearchParams}
            onClick={props.onSearchReset}
          >
            {labels.resetAdvancedSearchParams}
          </Button>
        </Col>
      ) : null}
      {props.onUpload ? (
        <SubmitButton
          text={labels.upload}
          disabled={props.disabled}
          onClick={props.onUpload}
        />
      ) : null}
      {props.onDelete ? (
        <Col md="auto" xs="auto" className="button-bar-cols">
          <SubmitButton
            type="delete"
            text={props.deleteText}
            onClick={props.onDelete}
            showLoader
          />
        </Col>
      ) : null}
      {props.onSave ? (
        <Col md="auto" xs="auto" className="button-bar-cols">
          <SubmitButton
            type="save"
            onClick={props.onSave}
            disabled={props.disabled}
            partyId={props.partyId}
            readOnly={props.readOnly}
          />
        </Col>
      ) : null}
    </Row>
  );
};
